import moment from 'moment'
import { ProjectStatus, ProjectStatuses } from './constants'

export type Project = {
  status: ProjectStatus,
  completedDate?: string | null,
  workareas: Workarea[] | null
}

export type Workarea = {
  id: number,
  status: ProjectStatus,
  completedDate?: string | null
}

export function createJobFinancialsData(analysisData: any) {
  if (!analysisData) return null
  const jobFinancialsData = {
    price: {
      estimated: analysisData.estimated.price,
      actual: analysisData.actual.price,
      final: analysisData.final.price
    },
    grossProfit: {
      estimated: {
        amount: analysisData.estimated.grossProfit.amount,
        percentage: analysisData.estimated.grossProfit.percent,
      },
      actual: {
        amount: analysisData.actual.grossProfit.amount,
        percentage: analysisData.actual.grossProfit.percent,
      },
      final: {
        amount: analysisData.final.grossProfit.amount,
        percentage: analysisData.final.grossProfit.percent
      }
    },
    netProfit: {
      estimated: {
        amount: analysisData.estimated.netProfit.amount,
        percentage: analysisData.estimated.netProfit.percent,
      },
      actual: {
        amount: analysisData.actual.netProfit.amount,
        percentage: analysisData.actual.netProfit.percent,
      },
      final: {
        amount: analysisData.final.netProfit.amount,
        percentage: analysisData.final.netProfit.percent
      }
    },
    estimated: {
      overhead: analysisData.estimated.costs.overhead,
      breakeven: analysisData.estimated.costs.breakeven,
      labor: analysisData.estimated.costs.labor,
      materials: analysisData.estimated.costs.materials,
      equipment: analysisData.estimated.costs.equipment,
      subcontracting: analysisData.estimated.costs.subcontracting
    },
    actual: {
      overhead: analysisData.actual.costs.overhead,
      breakeven: analysisData.actual.costs.breakeven,
      labor: analysisData.actual.costs.labor,
      materials: analysisData.actual.costs.materials,
      equipment: analysisData.actual.costs.equipment,
      subcontracting: analysisData.actual.costs.subcontracting
    },
    unbillable: {
      labor: analysisData.actual.unbillable.labor,
      materials: analysisData.actual.unbillable.materials,
      equipment: analysisData.actual.unbillable.equipment,
      subcontracting: analysisData.actual.unbillable.subcontracting
    }
  }

  return jobFinancialsData
}

export function onProjectStatusChange(project: Project, newStatus: ProjectStatus): Project | null {
  if (!project) return null
  return {
    ...project,
    status: newStatus,
    completedDate: newStatus === ProjectStatuses.Completed ? moment().format("YYYY-MM-DDTHH:mm:ss") : null,
  }
}


export function onProjectCompletedDateChange(project: Project, newCompletedDate: string): Project | null {
  if (!project) return null
  return {
    ...project,
    completedDate: newCompletedDate
  }
}

export function onWorkareasStatusChange(workareas: Workarea[] | null, newStatus: ProjectStatus): Workarea[] | null {
  if (!workareas) return null
  return workareas.map(workarea => ({
    ...workarea,
    status: newStatus,
    completedDate: newStatus === ProjectStatuses.Completed ? moment().format("YYYY-MM-DDTHH:mm:ss") : null
  }))
}

export function onWorkareasCompletedDateChange(workareas: Workarea[] | null, newCompletedDate: string): Workarea[] | null {
  if (!workareas) return null
  return workareas.map(workarea => ({ ...workarea, completedDate: newCompletedDate }))
}
